const Footer = () => {
  return (
    <p className="heading-card-title text-left text-[#898989]">
      Copyright © 2022 International Centre for Industrial Transformation Ltd.
    </p>
  );
};

export default Footer;
